import { fetchBonus } from "@shared/actions/bonuses";
import { fetchGames } from "@shared/actions/games";
import { getWebSocketStream } from "@shared/actions/jackpots";
import { fetchLanguage, getLobbyParams } from "@shared/actions/lobby";
import { checkUser } from "@shared/actions/user";
import {
  useBrands,
  useGames,
  useProviders,
  useTags,
} from "@shared/hooks/games";
import { useIsStreamIdExist } from "@shared/hooks/jackpots";
import { useLobbyParams } from "@shared/hooks/lobby";
import { useUserBankGroup, useUserState } from "@shared/hooks/user";
import { SentryService } from "@shared/services/sentry-service/sentry-service";
import { jackpotService } from "@shared/utils/jp-socket";
import { hasUser } from "@shared/utils/users";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

export function useQueryAllData() {
  const dispatch = useDispatch();
  const userState = useUserState();
  const providers = useProviders();
  const lobbyParams = useLobbyParams() ?? null;
  const brands = useBrands();
  const tags = useTags();
  const games = useGames();
  const bankGroup = useUserBankGroup();
  const bankGroupId = hasUser(userState) ? bankGroup : 0;
  const isWSSConnected = useIsStreamIdExist();

  const fetchAllData = useCallback(async () => {
    try {
      if (!lobbyParams) {
        dispatch(getLobbyParams());
      }

      if (!games) {
        dispatch(fetchGames(bankGroupId));
      }

      if (!isWSSConnected || !jackpotService.getConnection) {
        dispatch(getWebSocketStream());
      }

      dispatch(fetchBonus());
      dispatch(checkUser());
      dispatch(fetchLanguage());
    } catch (error: unknown) {
      if (error instanceof Error) {
        SentryService.sendMessage(error.message);
      }
    }
  }, [bankGroupId, isWSSConnected]);

  const isLoading =
    !Array.isArray(providers) ||
    !Array.isArray(brands) ||
    !Array.isArray(tags) ||
    !Array.isArray(games);

  return { fetchAllData, isLoading };
}
